import { FieldInputType } from 'constants/fields';
import { FieldType } from 'constants/formGenerator';
import { loanFeePaymentTimeOptions } from 'constants/options';

export const loanFeesFormFields = {
  cdSection: {
    type: FieldType.INPUT,
    nameInModel: 'loanFees[0].cdSection',
    inputProps: {
      type: FieldInputType.TEXT,
      label: 'Cd',
      placeholder: 'Cd',
      required: true,
      disabled: true,
      widthInColumns: 0.4,
      variant: 'outlined',
    },
  },
  feeTypeId: {
    type: FieldType.SELECT,
    nameInModel: 'loanFees[0].feeTypeId',
    inputProps: {
      options: [],
      label: 'Name',
      placeholder: 'Name',
      required: false,
      disableClearable: true,
      widthInColumns: 1.25,
      variant: 'outlined',
    },
  },
  feeTypeName: {
    type: FieldType.INPUT,
    nameInModel: 'loanFees[0].feeTypeName',
    inputProps: {
      type: FieldInputType.TEXT,
      label: 'Name',
      placeholder: 'Name',
      required: true,
      widthInColumns: 1.25,
      variant: 'outlined',
    },
  },
  feeProviderId: {
    type: FieldType.SELECT,
    nameInModel: 'loanFees[0].feeProviderId',
    inputProps: {
      options: [],
      label: 'Fee Provider',
      placeholder: 'Fee Provider',
      required: true,
      widthInColumns: 1.25,
      variant: 'outlined',
    },
  },
  feeProviderName: {
    type: FieldType.INPUT,
    nameInModel: 'loanFees[0].feeProviderName',
    inputProps: {
      type: FieldInputType.TEXT,
      label: 'Fee Provider',
      placeholder: 'Fee Provider',
      required: true,
      widthInColumns: 1.25,
      variant: 'outlined',
    },
  },
  feePayer: {
    type: FieldType.SELECT,
    nameInModel: 'loanFees[0].feePayer',
    inputProps: {
      options: [],
      label: 'Payer',
      placeholder: 'Payer',
      required: true,
      disableClearable: true,
      widthInColumns: 1,
      variant: 'outlined',
    },
  },
  paymentTime: {
    type: FieldType.SELECT,
    nameInModel: 'loanFees[0].paymentTime',
    inputProps: {
      options: loanFeePaymentTimeOptions,
      label: 'Payment time',
      placeholder: 'Payment time',
      required: true,
      disableClearable: true,
      widthInColumns: 1.2,
      variant: 'outlined',
    },
  },
  amount: {
    type: FieldType.INPUT,
    nameInModel: 'loanFees[0].amount',
    inputProps: {
      type: FieldInputType.CURRENCY,
      label: 'Amount',
      placeholder: 'Amount',
      required: true,
      widthInColumns: 0.7,
      variant: 'outlined',
      minValue: 0,
    },
  },
  includeIntoTotalLoanAmount: {
    type: FieldType.CHECKBOX,
    nameInModel: 'loanFees[0].includeIntoTotalLoanAmount',
    inputProps: {
      className: 'include-into-total-loan-amount-checkbox items-center',
      widthInColumns: 0.5,
      variant: 'outlined',
    },
  },
  financedAmount: {
    type: FieldType.INPUT,
    nameInModel: 'loanFees[0].financedAmount',
    inputProps: {
      type: FieldInputType.CURRENCY,
      label: 'Financed Amount',
      placeholder: 'Financed Amount',
      required: false,
      widthInColumns: 0.8,
      variant: 'outlined',
      minValue: 0,
    },
  },
  isNet: {
    type: FieldType.CHECKBOX,
    nameInModel: 'loanFees[0].isNet',
    inputProps: {
      className: 'net-checkbox',
      widthInColumns: 0.5,
      variant: 'outlined',
    },
  },
  isDeleted: { nameInModel: 'loanFees[0].isDeleted' }, // HACK_HACK: for correct isFormChanged state
};
